import React from "react";
import Button from "@material-ui/core/Button";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Copyright from "Components/Copyright";
import useAuth from "Hooks/Upload/useAuth";
import ReCAPTCHA from "react-google-recaptcha";
import queryString from "query-string";

import MuiAlert from "@material-ui/lab/Alert";
import useError from "Hooks/useError";
import { message } from "constants/message";

import Axios from "axios";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "2.5em",
    color: "#556cd6",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  toast: {
    width: "100%",
    margin: theme.spacing(3, 0, 2),
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
}));

export default function SignIn(props) {
  const stateError = useError();
  const messages = message();
  const auth = useAuth();

  const [mail, setMail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [recaptcha, setRecaptcha] = React.useState("");
  const { status } = queryString.parse(props.location.search);

  React.useEffect(() => {
    // ログイン済みの場合は初期画面へ遷移
    if (localStorage.getItem("uploadtoken")) {
      props.history.push("/upload/top");
    }

    // タイトル変更
    document.title = "Buzz Finder Upload";

    stateError.initialize();
    switch (status) {
      case "201":
        alert(messages.signIn.passwordReset);
        break;
      case "401":
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.signIn.authorization,
          },
        });
        break;
      case "404":
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.signIn.authorization,
          },
        });
        break;
      default:
        break;
    }
  }, []);

  const handleSubmit = async (e) => {
    
    e.preventDefault();
    Axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
    
    await Axios({
      method: "POST",
      url: "media/upload/authentication/login",
      data: {
        email: mail,
        password: password,
        "g-recaptcha-response": recaptcha,
      },
    }).then(result => {
      auth.login({
        token: result.data.data.bearer_token,
        user: result.data.data.user,
      });
    }).catch(errors => {
      const isError = true;
      let errorMsg = "";
      console.log(errors)
      console.log(errors.response)
      // レスポンスの内容によってメッセージを出し分け
      if (errors.response.data.errors) {
        errorMsg = messages.errorMsg.continuousLoginErr;
      } else {
        errorMsg = messages.errorMsg.requestLoginErr;
      }
      stateError.dispatch({
        type: "set",
        payload: {
          isError: isError,
          errorMsg: errorMsg,
        },
      });

      console.error("request err", errors);
      console.error("errors.response", errors.response);

      // recaptcha をリセット
      window.grecaptcha.reset();
      setRecaptcha("");
      throw errors;
    });
    
    props.history.push("/upload/top");
  };

  const onChange = (value) => {
    setRecaptcha(value);
  };

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  const classes = useStyles();

  return (
    <Container component="main" maxWidth="xs">
      <div className={classes.paper}>
        <h1 className={classes.title}>Buzz Finder Upload</h1>
        <Typography component="h1" variant="h5">
          ログイン
        </Typography>
        <ValidatorForm 
          className={classes.form} 
          onSubmit={handleSubmit} 
          onError={onError}
          method="post"
        >
          <TextValidator
            variant="outlined"
            margin="normal"
            fullWidth
            id="email"
            label="メールアドレス*"
            autoFocus
            value={mail}
            onChange={(event) => {
              setMail(event.target.value);
            }}
            validators={['required', 'isEmail']}
            errorMessages={[messages.validation.required, messages.validation.isEmail]}
          />
          <TextValidator
            variant="outlined"
            margin="normal"
            fullWidth
            label="パスワード*"
            type="password"
            id="password"
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
            }}
            validators={['required']}
            errorMessages={[messages.validation.required]}
          />
          <ReCAPTCHA
            sitekey="6Lc6iMIZAAAAAMJDC7Sw78HcKqw76XmCZvtQFmPH"
            onChange={onChange}
          />
          {stateError.state.isError && (
            <div className={classes.messsageWrapper}>
              <MuiAlert
                elevation={6}
                variant="filled"
                severity="error"
                className={classes.toast}
              >
                {stateError.state.errorMsg}
              </MuiAlert>
            </div>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={!recaptcha}
          >
            ログイン
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href="/upload/password_reset/request" variant="body2">
                パスワードを忘れた方はこちら
              </Link>
            </Grid>
          </Grid>
        </ValidatorForm>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
